import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import {
    AttendanceRepository,
    RequestGetStudentAttendancesPayload,
} from "@/entities/attendance/domain/repository";
import type { GetAttendeesResponseDto } from "@/entities/attendance/domain/dtos";

@singleton()
export default class AttendanceRepositoryImpl implements AttendanceRepository {
    constructor(@inject("HttpAdapter") private readonly httpAdaptor: HttpAdapter) {}

    public getStudentAttendances = async (payload: RequestGetStudentAttendancesPayload) => {
        let url = `/v1/students/${payload.studentId}/attendances?`;

        if (payload.size) {
            url += `size=${payload.size}&`;
        } else {
            url += `size=40&`;
        }

        if (payload.from) {
            url += `from=${payload.from}&`;
        }

        if (payload.to) {
            url += `to=${payload.to}&`;
        }

        if (payload.type) {
            payload.type.forEach((type) => {
                url += `type=${type}&`;
            });
        }

        if (payload.nextToken) {
            url += `nextToken=${payload.nextToken}&`;
        }

        const response = await this.httpAdaptor.get<GetAttendeesResponseDto>(url);

        return response;
    };
}
